import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Logo } from "@/components/Logo";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useAuth } from "@/context/AuthContext";
import { apiErr } from "@/lib/api";

export default function Register() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ name: "", company_name: "", email: "", phone: "", password: "" });
  const [loading, setLoading] = useState(false);
  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await register(form);
      toast.success("Portal activated");
      navigate("/portal");
    } catch (err) {
      toast.error(apiErr(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#F9FAFB] p-6">
      <div className="w-full max-w-md rounded-lg border border-[#E5E7EB] bg-white p-8">
        <Logo />
        <h1 className="mt-6 font-display text-3xl font-bold text-slate-900">Activate Your Portal</h1>
        <p className="mt-2 text-slate-500">Track orders, quotations and balances in one place.</p>
        <form onSubmit={submit} className="mt-6 space-y-4" data-testid="register-form">
          <div>
            <Label>Contact name</Label>
            <Input data-testid="reg-name" value={form.name} onChange={set("name")} className="mt-1.5" required />
          </div>
          <div>
            <Label>Company / Organisation</Label>
            <Input data-testid="reg-company" value={form.company_name} onChange={set("company_name")} className="mt-1.5" />
          </div>
          <div>
            <Label>Email</Label>
            <Input data-testid="reg-email" type="email" value={form.email} onChange={set("email")} className="mt-1.5" required />
          </div>
          <div>
            <Label>Phone</Label>
            <Input data-testid="reg-phone" value={form.phone} onChange={set("phone")} className="mt-1.5" />
          </div>
          <div>
            <Label>Password</Label>
            <Input data-testid="reg-password" type="password" value={form.password} onChange={set("password")} className="mt-1.5" required />
          </div>
          <Button type="submit" disabled={loading} data-testid="reg-submit"
            className="w-full h-11 bg-[#0A4F35] hover:bg-[#083D29] text-white font-semibold">
            {loading ? "Creating…" : "Activate Portal"}
          </Button>
        </form>
        <p className="mt-6 text-sm text-slate-500">
          Already registered? <Link to="/login" className="font-semibold text-[#0A4F35] hover:underline">Sign in</Link>
        </p>
      </div>
    </div>
  );
}
